export const toKebab = (string) => {
    return string
        .split("")
        .map((letter, index) => {
            if (/[A-Z]/.test(letter)) {
                return ` ${letter.toLowerCase()}`;
            }
            return letter;
        })
        .join("")
        .trim()
        .replace(/[_\s]+/g, "-");
};

export const toCamel = (string) => {
    return toKebab(string)
        .split("-")
        .map((word, index) => {
            if (index === 0) return word;
            return word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join("");
};

export const toPascal = (string) => {
    const interim = toCamel(string);
    return interim.slice(0, 1).toUpperCase() + interim.slice(1);
};

export const toTitle = (string) => {
    return toKebab(string)
        .split("-")
        .map((word) => {
            return word.slice(0, 1).toUpperCase() + word.slice(1);
        })
        .join(" ");
};

export const toSentence = (string) => {
    const interim = toKebab(string).replace(/-/g, " ");
    return interim.slice(0, 1).toUpperCase() + interim.slice(1);
};
